import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';

// We wrap in React.memo so this doesn't re-render 
// unless the loading prop specifically changes.
const SearchToolbar = React.memo(({ onSearch, onReset, loading, hasLoadedAnything, initialValue }) => {
    // Initialize state with the initialValue prop
    const [internalSearchText, setInternalSearchText] = useState(initialValue || '');

    const handleSearchClick = () => {
        onSearch(internalSearchText);
    };

    const handleResetClick = () => {
        setInternalSearchText('');
        onReset();
    };

    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', p: '12px 12px 0 12px' }}>
            <TextField
                size="small"
                label="Search Quizzes..."
                value={internalSearchText}
                onChange={(e) => setInternalSearchText(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') handleSearchClick();
                }}
                sx={{ width: 320 }}
            />
            <Button
                size="small"
                variant="contained"
                onClick={handleSearchClick}
                disabled={loading}
            >
                Search
            </Button>

            <Button
                size="small"
                variant="outlined"
                onClick={handleResetClick}
                disabled={loading}
            >
                Reset
            </Button>

            {!hasLoadedAnything && !loading && (
                <Typography sx={{ ml: 2 }} variant="body2" color="text.secondary">
                    Use Search or Reset to fetch quizzes.
                </Typography>
            )}
        </Box>
    );
});

export default SearchToolbar;